module.exports = __webpack_public_path__ + "static/customise-db7bc24444fc8dfa1cbe7c640b7aa622.png";